<div class="section">



    <!--     *********     BLOGS 1      *********      -->
    <div class="blog-1" id="blog-1">
        <div class="container">
            <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                    <h2 class="title">Developer Status</h2>
                    <br />
                    <div class="card card-plain card-blog">




                        <div class="col-md-5">
                            <div class="card-image">

                                <img crossorigin="anonymous" class="img" />
                            </div>
                        </div>
                        <div class="col-md-7">
                            <div class="card-body">
                                <h6 class="card-category text-info"></h6>
                                <h3 class="card-title">
                                    <a>Environment Settings</a>
                                </h3>
                                site_URL: {{dev_evn.site_URL}}<br>
                                fdn_URL: {{dev_evn.fdn_URL}}<br>
                                Production : {{dev_evn.production}}<br>
                                International Flag : {{dev_evn.is_international}}
                                <!-- <p class="card-description">
                                    <a href="javascript:void(0)"> Read More </a>
                                </p>
                                <p class="author">
                                    by <a href="javascript:void(0)"><b></b></a>
                                </p> -->
                            </div>

                        </div>
                    </div>




                </div>
            </div>
        </div>
    </div>

</div>